import React from 'react'

import SearchInput from '../../../components/SearchInput'
import Popover from '../../../containers/Popovers/components/Popover'
import styles from './SearchPopover.css'

const SearchPopover = props => {
  const {
    handleOnChange,
    handleOnOutsidePopoverClick,
    handleOnPopoverKeyUp,
    value,
    placeholder,
    autoFocus = true,
  } = props

  return (
    <Popover
      className={styles.searchPopover}
      onOutsidePopoverClick={handleOnOutsidePopoverClick}
    >
      <SearchInput
        onKeyUp={handleOnPopoverKeyUp}
        autoFocus={autoFocus}
        handleOnChange={handleOnChange}
        value={value}
        placeholder={placeholder}
      />
    </Popover>
  )
}

export default SearchPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/SearchPopover/SearchPopover.jsx